var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapbox-map-container"},[_c('mapbox',{ref:"mapboxMap",attrs:{"access-token":"pk.eyJ1IjoibWF4aXNtIiwiYSI6ImNqbDg0bHg4dzBkNjczdm84ZjRqZnFpcWMifQ.lekJSHeqixAGad36DXbEWg","map-options":{
      style: 'mapbox://styles/tomganchos/cl5klwnix002l14s01lf54ii8',
      zoom: 0,
      center: _vm.center ? _vm.center : undefined,
      preserveDrawingBuffer: true,
      trackResize: true,
    },"nav-control":{ show: false, position: 'bottom-right' }},on:{"map-load":_vm.mapLoaded}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }